import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function PageHeader({ title, pageUrl, page, subPage = null }) {
  const { t, i18n } = useTranslation();
  return (
    <div className="jumbotron jumbotron-fluid overlay">
      <div className="jumbo-heading">
        {/* Section Heading */}
        <div className="section-heading" data-aos="zoom-in">
          <h1>{title}</h1>
        </div>

        {/* Breadcrumb */}
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={i18n.language === 'bs' ? '/' : `/${i18n.language}`}>{t('nav.home')}</Link>
            </li>

            {page && (
              <li
                className={`breadcrumb-item${!subPage ? ' active' : ''}`}
                aria-current={!subPage ? 'page' : undefined}
              >
                {!subPage ? page : <Link to={i18n.language === 'bs' ? `/${pageUrl}` : `/${i18n.language}/${pageUrl}`}>{page}</Link>}
              </li>
            )}

            {subPage && (
              <li className="breadcrumb-item active" aria-current="page">
                {subPage}
              </li>
            )}
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default PageHeader;
